import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface CreateProjectResponse {
  id: string
}

export interface CreateProjectParams {
  companyId: string
  name: string
  fileS3Key?: string
  bots?: string[]
  active?: boolean
}

export async function createProject({
  companyId,
  name,
  fileS3Key,
  bots,
  active,
}: CreateProjectParams): Promise<CreateProjectResponse> {
  const resp = await api.post<CreateProjectResponse>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `company/${companyId}/project`,
    {
      body: {
        name,
        picture: fileS3Key,
        active,
        bots,
      },
    },
  )

  return resp.body
}
